import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { UtilizationReportTableComponent } from '../workcenter-utilization/utilization-report-table/utilization-report-table.component'
import { ProductivityReportTableComponent } from '../productivity/productivity-report-table/productivity-report-table.component'
import {
  ElderTabGroupRoutingDirective,
  ElderTabDirective,
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
} from '@elderbyte/ngx-starter'
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs'

@Component({
  selector: 'app-report-dashboard',
  templateUrl: './report-dashboard.component.html',
  styleUrls: ['./report-dashboard.component.scss'],
  imports: [
    MatTabGroup,
    ElderTabGroupRoutingDirective,
    MatTab,
    ElderTabDirective,
    MatTabContent,
    ProductivityReportTableComponent,
    UtilizationReportTableComponent,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class ReportDashboardComponent {}
